<template lang="pug">
.confirm-terminate-modal
  b-modal(ref="modal" size="lg" no-close-on-backdrop no-close-on-esc hide-header
    @ok="update" @cancel="cancel")
    .confirm-terminate-modal-body
      .confirm-title 解約依頼を行いますが、よろしいですか？
      .confirm
        .message 解約依頼前に以下をご確認ください。
        ul.confirm-list
          li 解約依頼を行っても、今月末まで引き続き本サービスはご利用可能です。
          li 解約後は現在登録している情報は失われます。
          li 必要があればバックアップをお願いいたします。
          li ご家族へ解約する旨をご周知ください。
        label
          input(type="checkbox" @click="checked = !checked")
          span 同意する

    div(slot="modal-footer" slot-scope="{ ok, cancel }")
      button.btn.modal-ok-btn(v-if="checked" type="button" @click="ok()") OK
      button.btn.modal-ok-btn.disable(v-else type="button" disabled) OK
      button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

/**
 * 解約確認モーダル
 */
@Component
export default class TerminateModal extends Vue {
  /** 更新対象名 */
  public checked: boolean = false;

  /**
   * モーダル表示
   */
  public show(): void {
    const modal: any = this.$refs.modal;
    this.checked = false;
    if (modal) {
      modal.show();
    }

    return;
  }

  /**
   * OKボタン押下イベント
   */
  private update(): void {
    this.$emit("register");

    return;
  }

  /**
   * キャンセルボタン押下イベント
   */
  private cancel(): void {
    this.$emit("cancel");

    return;
  }
}
</script>
